import * as fullScreenSelector from '../Fullscreen/selectors';
import { ReportsState } from './model'
import { AppState } from '../../types';
import { Environment } from '../../remote-api/CoreServicesRemoteApi';
import { Application } from '../../remote-api/models'

const getAll = (state: AppState): ReportsState => state.monitoring.reports;

export const getIsLoading = (state: AppState) => getAll(state).isLoading;
export const getSelectedType = (state: AppState) => getAll(state).selectedType;
export const getAllReportsApplications = (state: AppState) => getAll(state).applications;
export const getAllApplicationsARM = (state: AppState) => getAll(state).applicationsARM
export const getApplicationsData = (state: AppState) => getAll(state).applicationsData;
export const isFullscreen = (state: AppState) => fullScreenSelector.isFullscreen(state);
const getResources = (state: AppState) => state.monitoring.resources;

export const getAllEnvironments = (state: AppState): Environment[] =>
    getResources(state).environments.data;
export const getSelectedEnvironment = (state: AppState): string | undefined =>
    getResources(state).environments.selected;
export const getEnvironmentsLoading = (state: AppState): boolean =>
    getResources(state).environments.loading;
export const getAllApplications = (state: AppState): Application[] =>
  getResources(state).applications.data;
